import { gql } from "@apollo/client";

export const REALITY_DOCUMENTS_QUERY = gql`
  query RealityDocuments {
    realityDocuments {
      documents {
        id
        name
        status
        statusDetail
        pageCount
        sizeMb
        createdAt
        thumbnailUrl
        enabled
      }
    }
  }
`;